import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../../store/shared/api/endpoints';
import TransparentLogo from '../../store/shared/components/TransparentLogo';
import defaultLogo from '../../store/shared/assets/logo.png';
import ValidatedInput, { validateFields } from '../../validations/ValidatedInput';
import '../shell/admin.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('nv_admin_token');
    if (token) navigate('/admin/dashboard#intro', { replace: true });
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const errs = validateFields([
      { kind: 'email', value: email, required: true },
      { kind: 'password', value: password, required: true },
    ]);
    if (errs.length) {
      setError(errs[0]);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await authApi.adminLogin({
        email: email.trim().toLowerCase(),
        password,
      });
      const token = res?.data?.data?.token;
      if (!token) throw new Error('Login succeeded but no token was returned');
      localStorage.setItem('nv_admin_token', token);
      navigate('/admin/dashboard#intro', { replace: true });
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Login failed. Is the API running on port 5000?'
      );
      localStorage.removeItem('nv_admin_token');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__art" aria-hidden>
        <div className="admin-login__orb admin-login__orb--1" />
        <div className="admin-login__orb admin-login__orb--2" />
        <div className="admin-login__orb admin-login__orb--3" />
      </div>

      <form className="admin-login__card" onSubmit={onSubmit}>
        <div className="admin-login__brand">
          <TransparentLogo src={defaultLogo} alt="NAYAVARNAM" className="admin-login__logo" />
          <p className="admin-login__eyebrow">Admin sign in</p>
        </div>

        <label className="admin-login__field">
          <span>Email</span>
          <ValidatedInput
            kind="email"
            placeholder="admin@nayavarnam.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label className="admin-login__field">
          <span>Password</span>
          <ValidatedInput
            kind="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {error && <p className="admin-error">{error}</p>}
        <button type="submit" className="admin-login__submit" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        <Link to="/" className="admin-login__back">
          ← Back to storefront
        </Link>
      </form>
    </div>
  );
}
